import d3 = require("d3");
import _ = require('lodash');

import { Controller, DataLoader, Visualizer, DataSourceType, event } from "bvd3";
import editorDef from "./editor";
import "./index.sass";

// @ts-ignore
import * as template from "./template.bvt";

export const visualizer = new Visualizer(template, "#canvas", {
    useBVT: true,
    transformers: {},
    eventHandlers: {},
    data: {
        "top_margin": 50,
        "module_width": 120,
        "module_height": 40,
        "module_border_radius": 5,
        "repeat_offset": 8,
        "adjacent_dis_x": 60,
        "adjacent_dis_y": 60,
        "modules": []
    },
    beforeDraw() {
        visualizer.size.width = 2500;
    }
});

let modules = [];
let communities = [];
function handleData(d, inLoop = false) {
    d.forEach(element => {
        if ("module_name" in element) {
            if (inLoop) {
                element["in_loop"] = true;
            }
            element.inputs = Object.keys(element.inputs).map(key => {
                return ({
                    "prefix": key,
                    "value": element.inputs[key],
                    "in_loop": element.in_loop,
                    "visibility": element.in_loop ? "visible" : "hidden",
                });
            });
            modules.push(element);
            communities.push([element.module_name]);
        } else {
            Object.keys(element).forEach(key => {
                handleData(element[key], true);
            });
        }
    });
};

function moduleSort() {
    return modules.sort((a, b) => {
        if (a.depends_on.includes(b.module_name)) {
            return 1;
        } else if (b.depends_on.includes(a.module_name)) {
            return -1;
        }
        return 0;
    });
};

function computeModulePos() {
    const data = visualizer.data;
    modules.forEach(m => {
        m["blocks"] = [];
        m["visibility"] = m.in_loop ? "visible" : "hidden";
        const blockCount = m.in_loop ? 3 : 1;
        if (blockCount == 1) {
            m.blocks.push({
                "visibility": true,
                "x": 0,
                "y": 0,
            });
        }else {
            for (let i = 0; i < blockCount; i++) {
                m.blocks.push({
                    "visibility": i === 0 ? "visible" : m.visibility,
                    "x": data.repeat_offset * (2 - i),
                    "y": -data.repeat_offset * (2 - i),
                });
            }
        }
    });
};

function computeInputsPos() {
    modules.forEach(m => {
        const offset = (visualizer.data.module_width / 2 + visualizer.data.adjacent_dis_x / 2) * (m.inputs.length - 1);
        m.inputs.forEach((input, index) => {
            input["x"] = (visualizer.data.module_width + visualizer.data.adjacent_dis_x) * index - offset;
        });
    });
};

function computeInputPaths() {
    const data = visualizer.data;
    modules.forEach(m => {
        const inputsLength = m.inputs.length;
        const halfIndex = (inputsLength - 1) / 2;
        m.inputs.forEach((input, index) => {
            input["paths"] = [];
            input["blocks"] = [];
            const pathCount = input.in_loop ? 3 : 1;
            for (let i = 0; i < pathCount; i++) {
                // handle paths
                const tmpPath = {
                    "visibility": i === 0 ? "visible" : input.visibility,
                };
                const tmpBlock = {
                    "visibility": i === 0 ? "visible" : input.visibility,
                };
                const mvDownDist = data.adjacent_dis_y / 2 - data.repeat_offset * i;
                let mvXDist = 0;
                let pathX = 0;
                let x = 0;
                let y = 0;
                if (inputsLength % 2) {
                    mvXDist = (halfIndex - index) * ((data.module_width + data.adjacent_dis_x) / 2 - data.module_width / inputsLength);
                } else {
                    mvXDist = (halfIndex - index) / 0.5 * ((data.module_width + data.adjacent_dis_x) / 2 - data.module_width / inputsLength / 2);
                }
                if (index <= halfIndex) {
                    x = data.repeat_offset * (2 - i);
                    pathX = data.repeat_offset * i;
                } else {
                    x = -data.repeat_offset * (2 - i);
                    pathX = -data.repeat_offset * i;
                }
                if (pathCount == 3) {
                    x = data.repeat_offset * (2 - i);
                    y = -data.repeat_offset * (2 - i);
                } else {
                    x = 0;
                    y = 0;
                }
                tmpPath["d"] = `m 0,0 l 0,${mvDownDist} m 0,0 l ${mvXDist},0 m 0,0 l 0,${data.adjacent_dis_y / 2 - 10} `;
                tmpPath["d"] += "m 0,0 l -3,0 m 0,0 l 3,10 m 0,0 l 3,-10 m 0,0, l -3,0";
                tmpPath["x"] = pathX;
                input["paths"].push(tmpPath);
                tmpBlock["x"] = x;
                tmpBlock["y"] = y;
                input["blocks"].push(tmpBlock);
            }
        });
    });
};

// const computeCommunities = (() => {
//     modules.forEach(m => {
//         if (m.depends_on.length > 1) {
//             mergeCommunities(m.depends_on);
//         }
//     });
// });

// const mergeCommunities = (depends => {
//     const count = depends.length;
//     for (let i = 0; i < count - 1; i++) {
//         const m1 = depends[i];
//         for (let j = i + 1; j < count; j++) {
//             const m2 = depends[j];
//             const index1 = getCommunityIndex(m1);
//             const index2 = getCommunityIndex(m2);
//             if (index1 !== index2) {
//                 const tmp = communities[index1].concat(communities[index2]);
//                 if (index1 < index2) {
//                     communities[index1] = tmp;
//                     communities.splice(index2, 1);
//                 } else {
//                     communities[index2] = tmp;
//                     communities.splice(index1, 1);
//                 }
//             }
//         }
//     }
// });

function computeCommunities() {
    let communities_length = communities.length;
    for (let i = 0; i < communities_length - 1; i++) {
        let c1 = communities[i];
        let j = i + 1;
        let c2 = communities[j];
        while (!hasDependencies(c1, c2)) {
            mergeCommunities(c1, c2);
            communities_length = communities.length;
            if (j < communities_length){
                c1 = communities[i];
                c2 = communities[j];
            }else{
                break;
            }
        }
    }
};

function hasDependencies(c1, c2) {
    for (const mName of c2) {
        const m = modules[getModuleIndex(mName)];
        for (const name of m.depends_on) {
            if (c1.includes(name)) {
                return true;
            }
        }
    }
    return false;
};

function mergeCommunities(c1, c2) {
    const index1 = getCommunityIndex(c1[0]);
    const index2 = getCommunityIndex(c2[0]);
    if (index1 !== index2) {
        const tmp = communities[index1].concat(communities[index2]);
        if (index1 < index2) {
            communities[index1] = tmp;
            communities.splice(index2, 1);
        } else {
            communities[index2] = tmp;
            communities.splice(index1, 1);
        }
    }
};

const getCommunityIndex = m => _.findIndex(communities, (c) => c.includes(m));

const getModuleIndex = name => _.findIndex(modules, (m) => m.module_name === name);

const computeModuleWidth = m => m.inputs.length * visualizer.data.module_width + (m.inputs.length - 1) * visualizer.data.adjacent_dis_x;

function getCommunitiesMaxWidth() {
    console.log(communities);
    let maxWidth = 0;
    let maxSize = 0;
    let tmpSum = 0;
    communities.forEach(c => {
        c.forEach(name => {
            tmpSum += computeModuleWidth(modules[getModuleIndex(name)]);
        });
        if (maxWidth < tmpSum){
            maxWidth = tmpSum;
        }
        if (maxSize < c.length){
            maxSize = c.length;
        }
        tmpSum = 0;
    });
    console.log(maxWidth);
    return maxWidth + maxSize * visualizer.data.adjacent_dis_x;
}

function recomputeModulePos () {
    const data = visualizer.data;
    communities.forEach((c, i) => {
        const halfIndex = (c.length - 1) / 2;
        c.forEach((name, j) => {
            const m = modules[getModuleIndex(name)];
            let x = 0;
            let start = 0;
            let end = 0;
            if (c.length % 2) {
                start = j > halfIndex ? halfIndex : j;
                end = j > halfIndex ? j : halfIndex;
            } else {
                start = j > halfIndex ? c.length / 2 : j;
                end = j > halfIndex ? j + 1 : halfIndex;
            }
            const sign = Math.sign(j - halfIndex);
            for (let index = start; index < end; index++) {
                const width = computeModuleWidth(modules[getModuleIndex(name)]);
                if (index === j && c.length % 2 === 0 ) {
                    x += sign * (width + data.adjacent_dis_x) / 2;
                } else {
                    x += sign * (width + data.adjacent_dis_x);
                }
            }
            m["x"] = x;
            m["y"] = data.top_margin + (data.module_height + data.adjacent_dis_y) * 2 * i;
        });
    });
};

function computeModulePaths() {
    const data = visualizer.data;
    modules.forEach(m => {
        m["paths"] = [];
        m.inputs.forEach((input, inputIndex) => {
            const moduleOutputs = getModuleOutputs(input.value);
            const inputsLength = moduleOutputs.length;
            const halfIndex = (inputsLength - 1) / 2;
            moduleOutputs.forEach((output, index) => {
                const module = modules[getModuleIndex(output)];
                if (isAdjacent(module, m)) {
                    const pathCount = module.in_loop ? 3 : 1;
                    for (let i = 0; i < pathCount; i++) {
                        // handle paths
                        const tmpPath = {
                            "visibility": i === 0 ? "visible" : input.visibility,
                        };
                        const mvDownDist = data.adjacent_dis_y / 2 - data.repeat_offset * i;
                        let mvXDist = input.x + m.x - module.x;
                        if (input.in_loop) {
                            mvXDist += input.blocks[2].x;
                        } else {
                            mvXDist += input.blocks[0].x;
                        }
                        const pathX = data.repeat_offset * i;
                        if (inputsLength % 2) {
                            mvXDist += (halfIndex - index) * (data.module_width / inputsLength);
                        } else {
                            mvXDist += (halfIndex - index) / 0.5 * (data.module_width / inputsLength / 2);
                        }
                        tmpPath["d"] = `m 0,0 l 0,${mvDownDist} m 0,0 l ${mvXDist},0 m 0,0 l 0,${data.adjacent_dis_y / 2 - 10} `;
                        tmpPath["d"] += "m 0,0 l -3,0 m 0,0 l 3,10 m 0,0 l 3,-10 m 0,0, l -3,0";
                        tmpPath["x"] = pathX;
                        module["paths"].push(tmpPath);
                    }
                } else {
                    const pathCount = module.in_loop ? 3 : 1;
                    for (let i = 0; i < pathCount; i++) {
                        // handle paths
                        const tmpPath = {
                            "visibility": i === 0 ? "visible" : input.visibility,
                        };
                        const mvDownDist1 = data.adjacent_dis_y / 2 - data.repeat_offset * i;
                        const maxCommunityWidth = getMaxCommunityWidth(module.module_name, m.module_name);
                        const mvXDist1 = Math.sign(input.x + m.x - module.x - 1) * (maxCommunityWidth + data.adjacent_dis_x / 2);
                        const index1 = getCommunityIndex(module.module_name);
                        const index2 = getCommunityIndex(m.module_name);
                        const mvDownDist2 = (data.module_height + data.adjacent_dis_y) * 2 * Math.abs(index2 - index1 - 1);
                        let mvXDist2 = mvXDist1 - (input.x + m.x);
                        const pathX = data.repeat_offset * i;
                        if (inputsLength % 2) {
                            mvXDist2 += (halfIndex - index) * (data.module_width / inputsLength);
                        } else {
                            mvXDist2 += (halfIndex - index) / 0.5 * (data.module_width / inputsLength / 2);
                        }
                        tmpPath["d"] = `m 0,0 l 0,${mvDownDist1} m 0,0 l ${mvXDist1},0 m 0,0 l 0,${mvDownDist2} `;
                        tmpPath["d"] += `m 0,0 l ${mvXDist2},0 m 0,0 l 0,${data.adjacent_dis_y / 2 - 10} `;
                        tmpPath["d"] += "m 0,0 l -3,0 m 0,0 l 3,10 m 0,0 l 3,-10 m 0,0, l -3,0";
                        tmpPath["x"] = pathX;
                        module["paths"].push(tmpPath);
                    }
                }
            });
        });
    });
};

const isAdjacent = (m1, m2) => Math.abs(m1.y - m2.y) <= (visualizer.data.module_height + visualizer.data.adjacent_dis_y) * 2;

function getMaxCommunityWidth(m1, m2) {
    const index1 = getCommunityIndex(m1);
    const index2 = getCommunityIndex(m2);
    let maxWidth = 0;
    for (let i = index1 + 1; i < index2; i++) {
        let tmpWidth = 0;
        const c = communities[i];
        c.forEach(m => {
            tmpWidth += computeModuleWidth(modules[getModuleIndex(m)]);
        });
        maxWidth = Math.max(maxWidth, tmpWidth);
    }
    return maxWidth / 2;
};

function getModuleOutputs(v) {
    const tmp = [];
    if (v !== null) {
        if (Array.isArray(v)) {
            v.forEach(e => {
                if (e !== null) {
                    if (typeof (e) === "object" && "module" in e) {
                        tmp.push(e["module"]);
                    }
                }
            });
        } else if (typeof(v) === "object") {
            if ("module" in v) {
                tmp.push(v["module"]);
            }
        }
    }
    return tmp;
};

function startProcess(data) {
    modules =[];
    communities =[];
    handleData(data);
    moduleSort();
    computeModulePos();
    computeInputsPos();
    computeInputPaths();
    computeCommunities();
    recomputeModulePos();
    computeModulePaths();
    return modules;
};
event.on("refreshData", (_, data) => {
    visualizer.data.modules = startProcess(data);
    // visualizer.svg.attr('width', getCommunitiesMaxWidth());
    visualizer.svg.attr('height', (visualizer.data.module_height +
        visualizer.data.adjacent_dis_y) * communities.length * 2);
});

const dataLoader = new DataLoader({
    sources: {
        // hic_flow_json: {
        //     url: `/user/pipelines/${window.gon.pipeline.id}/flowchart_json/`,
        //     type: DataSourceType.JSON,
        //     loaded(d) {
        //         modules = [];
        //         communities = [];
        //         handleData(d.data);
        //         moduleSort();
        //         computeModulePos();
        //         computeInputsPos();
        //         computeInputPaths();
        //         computeCommunities();
        //         recomputeModulePos();
        //         computeModulePaths();
        //         this.data.modules = modules;
        //     },
        // },
    },
});

const controller = new Controller({ visualizer, dataLoader, editorDef });
controller.__name__ = "pipeline-flowchart";
visualizer.data.modules = startProcess(window.gon.flowchart_json);






// WEBPACK FOOTER //
// ./app/javascript/pipeline-flowchart/index.ts